export default __webpack_public_path__ + "static/media/logoColorM.6cd06584.webp";